export default "__VITE_ASSET__CAuh7L$j__"